import { GAMMA_HOST } from './constants';
import { fetchGammaEventCached } from './gammaEventCache';

export const GAMMA_FETCH_TIMEOUT_MS = 8000;

/**
 * @param {string} slug
 * @returns {Promise<object|null>}
 */
async function fetchGammaEventRaw(slug) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), GAMMA_FETCH_TIMEOUT_MS);

  try {
    const res = await fetch(`${GAMMA_HOST}/events?slug=${encodeURIComponent(slug)}`, {
      signal: controller.signal,
    });
    if (!res.ok) {
      console.warn(`[gamma] HTTP ${res.status} slug=${slug}`);
      return null;
    }

    const data = await res.json();
    return Array.isArray(data) ? data[0] || null : data || null;
  } catch (err) {
    const reason = err?.name === 'AbortError' ? 'timeout' : err?.message || err;
    console.warn(`[gamma] fetch failed slug=${slug}`, reason);
    return null;
  } finally {
    clearTimeout(timer);
  }
}

/**
 * @param {string} slug
 * @returns {Promise<object|null>}
 */
export async function fetchGammaEvent(slug) {
  const s = String(slug || '').trim();
  if (!s) return null;
  return fetchGammaEventCached(s, fetchGammaEventRaw);
}
